import { EventEmitter } from '@angular/core';
import { Component, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventModel } from 'projects/rms/app/api/models/event-model';
import { ParsEventService } from '../../../pars/pars-event.service';
import { BehaviorSubject } from 'rxjs';
import { RmsLoadingService } from '../../../shared/ui-rms/components/loading-spinner/rms-loading.service';
import { EventListViewService } from 'projects/rms/app/api/services/event-list-view.service';
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';
import { FindFilter } from 'projects/rms/app/api/models/find-filter';
import { LazyLoadEvent } from 'primeng/api';
import { EventListViewModel } from 'projects/rms/app/api/models/event-list-view-model';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import { ToastService } from 'projects/shared/core/services/toast.service';

@Component({
  selector: 'ndms-change-event',
  templateUrl: './change-event.component.html',
  styleUrls: ['./change-event.component.css']
})
export class ChangeEventComponent extends NdmsSafeSubscriber implements OnInit {
  @Output() update = new EventEmitter<any>();

  filter: FindFilter;
  isLoading: boolean = true;
  searchvalue: string = "";
  event: EventModel;
  includeInactive: boolean = false;
  recordCount: number = 0;
  first: number = 0;
  columns: any[] = [
    { header: "Event Name", field: "eventName" },
    { header: "Count", field: "parsCount" },
    { header: "Event Type", field: "eventType" },
    { header: "Start Date", field: "startDate" }
  ];

  private _events$ = new BehaviorSubject<EventListViewModel[]>([]);
  get events$() {
    return this._events$.asObservable();
  }
  get events() {
    return this._events$.value;
  }

  constructor(public modal: BsModalRef,
    private _eventListViewService: EventListViewService,
    private _parsEventService: ParsEventService,
    private _loadingService: RmsLoadingService,
    private _toastService: ToastService,
    private _datePipe: DatePipe,
    private _router: Router) {
    super();
  }

  ngOnInit() {
    this.initializeFilter();
  }

  onSetCurrent(event: EventListViewModel) {
    this._loadingService.setLoading('Changing...')
      .then(() => this._parsEventService.getEvent(event.eventId))
      .then(event => this._parsEventService.setCurrentEvent(event))
      .then(event => this.update.emit(event))
      .then(() => this.modal.hide())
      .finally(() => this._loadingService.setNotLoading());
  }

  onClearEvent() {
    this._loadingService.setLoading('Clearing...')
      .then(() => this._parsEventService.clearCurrentEvent(this.event))
      .then(() => this.update.emit(undefined))
      .then(() => this.modal.hide())
      .finally(() => this._loadingService.setNotLoading());
  }

  loadEvents() {
    this.safeSubscribe(this._eventListViewService.FindInDomain(this.filter), (data: EventListViewModel[]) => {
      if (data && data.length) {
        this._events$.next(data);
        this.recordCount = data["TotalRecordCount"];
      }
      this.isLoading = false;
    },
    error => {
      this._toastService.showError(error);
    });
  }

  onSearch(event) {
    let searchValue = event.target.value;

    if (searchValue.length > 0) {
      this.filter.findKeys["EventName stWt"] = "";
      this.filter.findKeys["EventName stWt"] += event.target.value;
    } else {
      delete this.filter.findKeys["EventName stWt"];
    }
    this.loadEvents();
  }

  onReloadList(event: LazyLoadEvent) {
    this.first = event.first;
    let pageNumber = this.first / event.rows;
    let pageSize = event.rows;
    const direction = event.sortOrder === -1 ? true : false;

    if (this.filter.sortInfos.length > 0 &&
      (this.filter.sortInfos[0].columnName.toLowerCase() !== event.sortField.toLowerCase()
        || this.filter.sortInfos[0].isDescending !== direction)) {
      this.first = 0;
      pageNumber = this.first / event.rows;
      pageSize = pageSize;
    }

    this.filter["sortInfos"] = this.sortOnfields(event.sortField, direction);
    this.filter["pagingInfo"] = {
      "pageNumber": pageNumber,
      "pageSize": pageSize
    };

    this.loadEvents();
  }

  onIncludeInactiveEventsChange(event) {
    if (event.checked) {
      delete this.filter.findKeys["EndDate"];
    }
    else {
      this.first = 0;
      this.initializeFilter();
    }

    this.loadEvents();
  }

  goToEvent(eventId) {
    this._router.navigateByUrl(`/rms/events/event-search/event/${eventId}`);
//    this.modal.hide();
  }

  private initializeFilter() {
    this.filter = Object.assign({},
      {
        findKeys: {
          "Active": "true",
          "EndDate": this._datePipe.transform(new Date(), "MM/dd/yyyy") 
        },
        pagingInfo: {
          "pageNumber": this.first / 10,
          "pageSize": 10
        },
        sortInfos: [
          {
            columnName: "StartDate",
            isDescending: true
          }
        ]
      });
  }

  private sortOnfields(sortField: string, direction: boolean) {
    let sortInfo = [];

    switch (sortField) {
      case "eventName":
        sortInfo = [
          {
            columnName: "EventName",
            isDescending: direction
          }
        ];
        break;
      case "eventType":
        sortInfo = [
          {
            columnName: "EventType",
            isDescending: direction
          }
        ];
        break;
      case "parsCount":
        sortInfo = [
          {
            columnName: "ParsCount",
            isDescending: direction
          }
        ];
        break;
      case "startDate":
        sortInfo = [
          {
            columnName: "StartDate",
            isDescending: direction
          }
        ];
        break;
    }
    return sortInfo;
  }
}
